<div class="component">
  <div>
    <div class="title">
      <h2 class="title title-primary">Bem-vindo Fulano</h2>
      <p class="description description-primary">O que deseja fazer hoje?</p>
    </div>
    <div>
      <button class="btn btn-primary" [routerLink]="['/cadastrarpedido']">Cadastrar Novo Pedido</button>  
      <button class="btn btn-second" [routerLink]="['/listarpedido']">Listar Pedidos</button>  
    </div>
    <div class="quit">
      <button class="btn-quit " [routerLink]="['/']">Sair</button> 
    </div>
  </div>
  
</div>


